import React from 'react';
import { motion } from 'framer-motion';
import { Button, NeuralBackground } from './ui';
export const ProblemSolution = () => {
  return <section className="py-24 bg-navy relative overflow-hidden" data-id="element-441">
      <div className="absolute inset-0 z-0" data-id="element-442">
        <img src="https://images.unsplash.com/photo-1475721027785-f74eccf877e2?auto=format&fit=crop&w=1920&q=80" alt="" className="w-full h-full object-cover opacity-[0.07]" data-id="element-443" />
        <div className="absolute inset-0 bg-navy/80" data-id="element-444" />
      </div>
      <NeuralBackground data-id="element-445" />
      <div className="container mx-auto px-6 relative z-10" data-id="element-446">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="max-w-4xl mx-auto" data-id="element-447">
          <h2 className="font-serif text-4xl md:text-5xl font-bold text-white mb-16 text-center leading-tight" data-id="element-448">
            Știi ce ai de făcut. Dar tot nu faci.{' '}
            <br className="hidden md:block" data-id="element-449" />
            <span className="text-gold" data-id="element-450">Sau o faci, dar nu iese cum vrei.</span>
          </h2>
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="bg-navy-card border border-gold/30 p-8 md:p-12 relative overflow-hidden" data-id="element-451">
            <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-gold/20 via-gold to-gold/20" data-id="element-452" />
            <div className="space-y-8" data-id="element-453">
              <p className="font-sans text-white text-xl leading-relaxed" data-id="element-454">
                Ești un om activ. Lucrezi, te implici, încerci. Dar în unele
                conversații simți că vorbești cu peretele. Iei decizii și
                imediat te gândești că poate greșești. Te oprești înainte să
                începi. Unele amintiri îți taie energia exact când ai mai mare
                nevoie de ea. Și nu înțelegi de ce.
              </p>
              <p className="font-sans text-white text-xl leading-relaxed" data-id="element-455">
                Dacă rămâi în același tipar, pierzi mai mult decât timp. Relații
                care s-ar putea îmbunătăți rămân încremenite. Obiective pe care
                le știi clare se pierd undeva între gânduri. Iar energia pe care
                o consumi luptând cu tine costă enorm, zi de zi.
              </p>
              <div className="w-full h-px bg-gold/20" data-id="element-456" />
              <p className="font-sans text-white text-xl leading-relaxed" data-id="element-457">
                <strong className="text-gold font-serif text-2xl md:text-3xl block mb-4" data-id="element-458">
                  NLP Practitioner Online, Live
                </strong>
                este programul practic de 7 luni în care înveți cum funcționează
                mintea ta. Cum îți schimbi tiparele care te țin pe loc. Cum
                comunici mai bine cu oamenii din jurul tău. Cum atingi obiective
                fără să te mai sabotezi. Și pleci cu certificare NLP națională
                și internațională recunoscută.
              </p>
              <div className="mt-8 text-center" data-id="element-459">
                <Button data-id="element-460">Scrie-mi pe WhatsApp pentru detalii!</Button>
              </div>
            </div>
          </motion.div>
        </motion.div>
      </div>
    </section>;
};